import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M11 5.12H9.01c-.837 0-1.51-.67-1.51-1.509V1.014L7.485 1h-5.12C2.154 1 2 1.152 2 1.346v11.308c0 .194.154.346.365.346h8.27c.211 0 .365-.152.365-.346V5.12zM8.5 1.945V3.61c0 .286.224.51.51.51h1.827L8.5 1.944zM10.635 14h-8.27C1.605 14 1 13.404 1 12.654V1.346C1 .596 1.605 0 2.365 0h5.266c.156 0 .293.058.41.154l3.783 3.52a.588.588 0 0 1 .176.422v8.558c0 .75-.605 1.346-1.365 1.346z",
		fill: "currentColor"
	})]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20viewBox%3D%220%200%2014%2014%22%3E%3Cpath%20d%3D%22M11%205.12H9.01c-.837%200-1.51-.67-1.51-1.509V1.014L7.485%201h-5.12C2.154%201%202%201.152%202%201.346v11.308c0%20.194.154.346.365.346h8.27c.211%200%20.365-.152.365-.346V5.12zM8.5%201.945V3.61c0%20.286.224.51.51.51h1.827L8.5%201.944zM10.635%2014h-8.27C1.605%2014%201%2013.404%201%2012.654V1.346C1%20.596%201.605%200%202.365%200h5.266c.156%200%20.293.058.41.154l3.783%203.52a.588.588%200%200%201%20.176.422v8.558c0%20.75-.605%201.346-1.365%201.346z%22%20fill%3D%22currentColor%22%2F%3E%3C%2Fsvg%3E";
